import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
export class SubscriptionsRepositoryService {
    constructor(http) {
        this.http = http;
    }
}
SubscriptionsRepositoryService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function SubscriptionsRepositoryService_Factory() { return new SubscriptionsRepositoryService(i0.ɵɵinject(i1.HttpClient)); }, token: SubscriptionsRepositoryService, providedIn: "root" });
